/* The viewer's own totals, above the board. */
.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(8rem, 1fr));
  gap: var(--space-3);
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
  padding: var(--space-4);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}

.figure {
  font-size: var(--text-xl);
  font-weight: 600;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}

.label {
  font-size: var(--text-xs);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-subtle);
}

/* The board component is built for a narrow column; constrained here so it
   does not stretch across a desktop page. */
.boardWrap {
  max-width: 30rem;
  padding: var(--space-4);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}
